module.exports = __webpack_public_path__ + "static/media/liliana_azevedo.8987638d.jpg";